import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MaterialReceipt, MaterialReceiptCreate, MaterialReceiptFilter } from '../data/materialReceipt';

export function createMaterialReceiptService(client: AxiosInstance) {
  return createCrudService<MaterialReceipt, MaterialReceiptCreate, MaterialReceiptFilter>(
    client,
    '/manufacturing/MaterialReceipt',
    'id',
  );
}

export type MaterialReceiptService = CrudService<MaterialReceipt, MaterialReceiptCreate, MaterialReceiptFilter>;
